import { connect } from "react-redux";
import ProductsList from "./products";
import { bindActionCreators } from "redux";
import { getProducts } from "services/redux/brandActivtion/products/action"

const mapStateToProps = (state) => {
  return ({
  viewProducts: state.productsReducer.viewProducts
});}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getProducts }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProductsList);
